import { Checkbox, Space, Typography } from 'antd';
import moment from 'moment';
import React from 'react';
import { PricingAPI } from '../../../../../controller/PricingAPI';
import { notifyTodosChanged, showChecklistError } from '../todoHelpers';

// 清單內容在新增待辦或新增例行工作時設定，這裡只能勾選 (canTick 歸負責人)。
// 資料變更後呼叫 onChanged，讓外層重抓，而不是在這裡自己維護一份狀態。
function TodoChecklist({ todo, canTick, onChanged }) {
    const [busy, setBusy] = React.useState(false);
    const items = todo.items || [];

    const act = (promise) => {
        setBusy(true);
        promise.then(() => {
            notifyTodosChanged();
            if (onChanged) {
                onChanged();
            }
        }).catch((error) => {
            showChecklistError(error);
            // 項目可能已被別人刪掉，重抓才不會留殘影
            if (onChanged) {
                onChanged();
            }
        }).finally(() => setBusy(false));
    };

    const handleToggle = (item, checked) => {
        act(PricingAPI.todos.items.update(todo.id, item.id, { done: checked }));
    };

    if (items.length === 0) {
        return null;
    }

    return (
        <div style={{ marginTop: 12 }} onClick={(e) => e.stopPropagation()}>
            <Typography.Title level={5}>檢查清單</Typography.Title>
            {items.map((item) => (
                <div key={item.id ?? `v${item.sort_order}`} style={{ marginBottom: 4 }}>
                    <Space size={8} wrap>
                        <Checkbox
                            checked={item.done}
                            disabled={!canTick || busy}
                            onChange={(e) => handleToggle(item, e.target.checked)}
                        >
                            {item.label}
                        </Checkbox>
                        {item.done ? (
                            <Typography.Text type="secondary" style={{ whiteSpace: 'nowrap' }}>
                                由 {item.done_by ? item.done_by.name : '未知'} 於 {item.done_at ? moment(item.done_at).format('MM/DD HH:mm') : ''}
                            </Typography.Text>
                        ) : null}
                    </Space>
                </div>
            ))}
        </div>
    );
}

export default TodoChecklist;
